
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlarmGeneral as ObiAlarmGeneralElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alarm-general.js';
 
 
 

 
 export const ObiAlarmGeneral = createComponent({
   react: React,
   tagName: 'obi-alarm-general',
   elementClass: ObiAlarmGeneralElement,
   events: {
     
   }
  });
 
 